<template>
    <div>
        <Sidebar />
        <div id="main" :class="sidebarActive ? 'full-width' : ''">
            <slot></slot>
        </div>
    </div>
</template>

<script>

import { mapState } from 'vuex';
import Sidebar from './Sidebar';
export default {
    name: 'Main',
    components: { Sidebar },
    computed: {
        ...mapState({
            pageTitle: state => state.app.pageTitle,
            sidebarActive: state => state.sidebar.active
        })
    },

    mounted () {
        document.title = this.pageTitle;
    },

    watch: {
        pageTitle (to, from) {
            document.title = to;
        }
    }
};
</script>
